import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'core-block-ui',
    templateUrl: './core-block-ui.component.html',
    styleUrls: ['./core-block-ui.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CoreBlockUiComponent {
  constructor() {}
}
